export const validateJSONforInput = (json?: string) => {
  if (!json) return false;

  try {
    return !JSON.parse(json);
  } catch {
    return 'This is not a valid JSON';
  }
};
